












import { defineComponent, ref } from "@vue/composition-api";
import { onClickOutside } from "@vueuse/core";
import { BButton } from "bootstrap-vue";
import { VEmojiPicker } from "v-emoji-picker";
import { IEmoji } from "v-emoji-picker/lib/models/Emoji";

export default defineComponent({
    components: {
        BButton,
        VEmojiPicker,
    },
    setup(_, { emit }) {
        const emojiPicker = ref(null);
        const showEmojiPicker = ref(false);

        onClickOutside(emojiPicker, () => (showEmojiPicker.value = false));

        const selectEmoji = (emoji: IEmoji) => {
            showEmojiPicker.value = false;
            emit!("select-emoji", emoji);
        };

        return {
            emojiPicker,
            showEmojiPicker,
            selectEmoji,
        };
    },
});
